import React, { useContext, useEffect, useRef, useState } from "react";
import "../home/Home.scss";
import { PageRoutes } from "../../utils/pageRoutes";
import {
  FileText,
  Building2,
  DollarSign,
  TrendingUp,
  Shield,
  Globe,
  Eye,
  Target,
  Clock,
  Sparkles,
  Zap,
  HelpCircle,
  FileSpreadsheet,
  ArrowRight,
  Briefcase,
  MessageCircleQuestion,
  Brain,
  Lock,
  Cpu,
  CheckCircle,
  XCircle,
} from "lucide-react";

import "./investorCenter.scss";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
} from "@mui/material";

import { useLocation, useNavigate } from "react-router-dom";
import parser from "html-react-parser";
import useGeoLocation from "../../components/geoLocation/GeoLoaction";
import { Context } from "../../contextApi/contextProvider";
import InvestorPop from "../../utils/popMenu/InvestorPop";
import PpmPop from "../../utils/popMenu/PpmPop";
import {
  ShimmerLoaderwhite,
  ShimmerLoader,
  ShimmerLoaderOneLine,
} from "../../utils/loader/ShimmerLoader";
import {
  cmsPublicContent,
} from "../../utils/cmscontent/cms";

import "../../pages/PPMContent/PPMContent.scss";
import { motion } from "framer-motion";
import PopupModal, {
  AccessDeniedModal,
  PandingModal,
} from "../../utils/popMenu/PopModel";
import { ref } from "yup";
import { getDocumentSection } from "../../pages/PPMContent/Intro";
import { RequestNextStage } from "../../utils/Api/api";
import { NavbarPandingPop } from "../../utils/popMenu/navbarPandingPop";
import IntroPop from "../../utils/popMenu/IntrorPop";
interface Document {
  post_id: string;
  post_name: string;
  document_status: string;
}


const InvestorCenter = () => {
  const loaction = useGeoLocation();
  const navigate = useNavigate();
  const { userLoginData, setUserLoginData, accessDoc, setAccessDoc } =
    useContext(Context);
  const [htmlString, setHtmlStr] = useState("");
  const [investorPop, setInvestorPop] = useState(false);
  const [ppmPop, setppmPop] = useState(false);
  const [showAccessDenied, setShowAccessDenied] = useState(false);
  const [deniedDocument, setDeniedDocument] = useState("");
  const [showPanding, setShowPanding] = useState("");
  const [ShowCEOPopup, setShowCEOPopup] = useState(false);
  const [pendingPop, setpendingPop] = useState(false);
  const [showFinancialPopup, setShowFinancialPopup] = useState(false);
  const [showInvestmentPopup, setShowInvestmentPopup] = useState(false);
  const [showGovernancePopup, setShowGovernancePopup] = useState(false);
  const [PandingBussines, setPandingBussines] = useState(false);
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);
  const introRef = useRef<HTMLDivElement>(null);
  const beRef = useRef<HTMLDivElement>(null);
  const fsRef = useRef<HTMLDivElement>(null);
  const iiRef = useRef<HTMLDivElement>(null);
  const ccRef = useRef<HTMLDivElement>(null);
  const wwRef = useRef<HTMLDivElement>(null);
  const scrollToSection = (ref: React.RefObject<HTMLDivElement>) => {
    if (ref.current) {
      const top = ref.current.getBoundingClientRect().top + window.scrollY - 70; // offset 70px
      window.scrollTo({
        top,
        behavior: "smooth",
      });
    }
  };
  const menuItems = [
    {
      id: 1,
      title: "Intro",
      icon: FileText,
      ref: introRef,
    },
    {
      id: 2,
      title: "Business Plan",
      icon: Building2,
      ref: beRef,
    },
    {
      id: 3,
      title: "Financial Summary",
      icon: DollarSign,
      ref: fsRef,
    },
    {
      id: 4,
      title: "Investor Instrument",
      icon: TrendingUp,
      ref: iiRef,
    },
    {
      id: 5,
      title: "Corporate Governance",
      icon: Shield,
      ref: ccRef,
    },
    {
      id: 6,
      title: "WWW",
      icon: Globe,
      ref: wwRef,
    },
  ];
  useEffect(() => {
    if (loaction.coordinates?.lat && loaction.coordinates?.lng) {
      const fetchCmsContent = async () => {
        const response = await cmsPublicContent({
          post_id: "6908",
          lat: loaction.coordinates.lat,
          log: loaction.coordinates.lng,
        });
        setHtmlStr(response);
      };

      fetchCmsContent();
    }

    window.scrollTo(0, 0);
    document.title = "TICCA | INVESTOR relations";
  }, []);

  const cards = [
    {
      href: `${PageRoutes.ExecutiveSummary}`,
      postId: "13678",
      title: `${htmlString[21]}`,
      icon: <Briefcase className="icon" />,
      description: `${htmlString[22]}`,
    },
    {
      href: `${PageRoutes.qa}`,
      postId: "9431",
      title: `${htmlString[23]}`,
      icon: <MessageCircleQuestion className="icon" />,
      description: `${htmlString[24]}`,
    },
    {
      postId: "13029",
      title: `${htmlString[25]}`,
      href: `${PageRoutes.AI_Executive_Summary}`,
      icon: <Brain className="icon" />,
      description: `${htmlString[26]}`,
    },
  ];
  const policies = [
    {
      id: 1,
      title: `${htmlString[35]}`,
      icon: <Shield className="tcg__icon" />,
      locked: true,

      description: `${htmlString[36]}`,
      onClick: () => setShowGovernancePopup(true),
      href: `${PageRoutes.CorporateGovernancePolicy}`,
    },
    {
      id: 2,
      href: `${PageRoutes.AntiFraudPolicy}`,
      title: `${htmlString[37]}`,
      icon: <Shield className="tcg__icon" />,
      locked: false,
      description: `${htmlString[38]}`,
    },
    {
      id: 3,
      href: `${PageRoutes.WhistleblowerPolicy}`,
      title: `${htmlString[39]}`,
      icon: <MessageCircleQuestion className="tcg__icon" />,
      locked: false,
      description: `${htmlString[40]}`,
    },
    {
      id: 4,
      href: `${PageRoutes.DataSecurityPolicy}`,
      title: `${htmlString[41]}`,
      locked: false,
      icon: <Lock className="tcg__icon" />,
      description: `${htmlString[42]}`,
    },
    {
      id: 5,
      href: `${PageRoutes.PrivacyPolicy}`,
      title: `${htmlString[43]}`,
      locked: false,
      icon: <Eye className="tcg__icon" />,
      description: `${htmlString[44]}`,
    },
    {
      id: 6,
      href: `${PageRoutes.TeamsOfUse}`,
      title: `${htmlString[45]}`,
      locked: false,
      icon: <FileText className="tcg__icon" />,
      description: `${htmlString[46]}`,
    },
    {
      id: 7,
      href: `${PageRoutes.CookiePolicy}`,
      title: `${htmlString[47]}`,
      locked: false,
      icon: <Globe className="tcg__icon" />,
      description: `${htmlString[48]}`,
    },
  ];
  return (
    <>
 
      {investorPop && <IntroPop setInvestorPop={setInvestorPop} />}
      <AccessDeniedModal
        showAccessDenied={showAccessDenied}
        setShowAccessDenied={() => setShowAccessDenied(false)}
        deniedDocument={deniedDocument}
      />
      <PandingModal
        showAccessDenied={PandingBussines}
        setShowAccessDenied={() => setPandingBussines(false)}
        deniedDocument={"Business Plan"}
      />
      <NavbarPandingPop
        showAccessDenied={pendingPop}
        setShowAccessDenied={setpendingPop}
      />
      {/* CEO Popup */}
      <PopupModal
        show={ShowCEOPopup}
        onClose={() => setShowCEOPopup(false)}
        title="Access Requirements"
        description="Read the TICCA Intro documents to unlock CEO access."
        type="ceo"
        showRequirements
        requirements={["Intro", "FAQ", "Fact Sheet"]}
        lockedDocs={["Business Summary", "Q & A", "AI Executive Summary"]}
      />
      <PopupModal
        show={showFinancialPopup}
        onClose={() => setShowFinancialPopup(false)}
        title="Confidential Document"
        description="To maintain confidentiality, this document will be provided after your discussion with our CEO."
        type="accessDenied"
      />
      <PopupModal
        show={showInvestmentPopup}
        onClose={() => setShowInvestmentPopup(false)}
        title="Confidential Document"
        description="To maintain confidentiality, this document will be provided after your discussion with our CEO."
        type="accessDenied"
      />
      <PopupModal
        show={showGovernancePopup}
        onClose={() => setShowGovernancePopup(false)}
        title="Confidential Document"
        description="To maintain confidentiality, this document will be provided after your discussion with our CEO."
        type="accessDenied"
      />
        { userLoginData.status === 0  ? <div style={{width:"80vw",height:"90vh",margin:"100px auto auto auto"}}   className="page-shimmer" ></div> : 
        <>
    <div className="investment-overview">
        <div className="overview-container">
          {/* Hero Content */}
          {!htmlString[10] && (
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <ShimmerLoaderwhite />
            </div>
          )}
          <div className="hero-content">
            {htmlString[0] && parser(htmlString[0])}
            {htmlString[1] && parser(htmlString[1])}
          </div>

          {/* Menu Items Grid */}
          {userLoginData?.status === 200 && (
            <div className="menu-grid">
              {menuItems.map((item) => {
                const Icon = item.icon;
                return (
                  <button
                    key={item.id}
                    type="submit"
                    onClick={() => scrollToSection(item.ref)}
                    className="menu-item"
                  >
                    <div className="icon-container">
                      <div className="icon-box">
                        <Icon className="icon" strokeWidth={1.5} />
                      </div>
                    </div>
                    <h3>{item.title}</h3>
                  </button>
                );
              })}
            </div>
          )}
          {userLoginData.status !== 200 && (
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                onClick={() => {
                  let Api_URL: any = "";
                  const env = process.env.REACT_APP_STAGE_ENV;
                  switch (env) {
                    case "dev":
                      Api_URL = process.env.REACT_APP_TICCA_DEV_SINUP;
                      break;
                    case "stage":
                      Api_URL = process.env.REACT_APP_TICCA_STAGE_SINUP;
                      break;
                    case "prod":
                      Api_URL = process.env.REACT_APP_TICCA_PRO_SINUP;
                      break;
                    default:
                      Api_URL = process.env.REACT_APP_TICCA_DEV_SINUP;
                      break;
                  }

                  window.location.href = Api_URL;
                }}
                className="btn-ticca"
                type="submit"
              >
                Register
              </Button>
            </div>
          )}
        </div>
      </div>
      <div className="vision-mission-section">
        {/* Animated Background Elements */}
        <motion.div
          className="bg-blob cyan"
          animate={{ x: [0, 100, 0], y: [0, 50, 0] }}
          transition={{ duration: 20, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.div
          className="bg-blob purple"
          animate={{ x: [0, -100, 0], y: [0, -50, 0] }}
          transition={{ duration: 25, repeat: Infinity, ease: "easeInOut" }}
        />

        <div className="container">
          {/* Intro Text */}
          <motion.div
            className="intro"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
        

            <motion.h1
              className="intro-title"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              {htmlString[3] ? parser(htmlString[3]) : <ShimmerLoaderOneLine />}
            </motion.h1>

            <motion.p
              className="intro-text"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              {htmlString[4] && parser(htmlString[4])}
            </motion.p>
            {!htmlString[4] && (
              <div
                style={{
                  margin: "10px auto",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <ShimmerLoader />
              </div>
            )}
          </motion.div>

          {/* Vision Mission Passion Cards */}
          <motion.div
            className="cards-section"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.6 }}
          >
            <motion.h2
              className="section-title"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.7 }}
            >
              {htmlString[4] && parser(htmlString[5])}
            </motion.h2>
            {!htmlString[4] && (
              <div
                style={{
                  margin: "10px auto",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <ShimmerLoaderOneLine />
              </div>
            )}
            <div className="cards-grid">
              {/* VISION */}
              <motion.div
                className="card blue"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.8 }}
                whileHover={{ y: -10, scale: 1.02 }}
                onHoverStart={() => setHoveredCard(0)}
                onHoverEnd={() => setHoveredCard(null)}
              >
                <div className="card-glow" />
                <div className="card-content">
                  <motion.div
                    animate={
                      hoveredCard === 0
                        ? { rotate: [0, 10, -10, 0], scale: [1, 1.1, 1] }
                        : {}
                    }
                    transition={{ duration: 0.5 }}
                    className="icon-box"
                  >
                    <Eye className="icon" />
                  </motion.div>

                  {htmlString[6] && parser(htmlString[6])}
                  {!htmlString[4] && <ShimmerLoaderOneLine />}

                  {htmlString[7] && parser(htmlString[7])}
                  {!htmlString[7] && <ShimmerLoaderwhite />}
                  <motion.div
                    className="card-blob"
                    animate={{ scale: hoveredCard === 0 ? [1, 1.5, 1] : 1 }}
                    transition={{ duration: 2, repeat: Infinity }}
                  />
                </div>
              </motion.div>

              {/* MISSION */}
              <motion.div
                className="card orange"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.9 }}
                whileHover={{ y: -10, scale: 1.02 }}
                onHoverStart={() => setHoveredCard(1)}
                onHoverEnd={() => setHoveredCard(null)}
              >
                <div className="card-glow" />
                <div className="card-content">
                  <motion.div
                    animate={
                      hoveredCard === 1
                        ? { rotate: [0, 10, -10, 0], scale: [1, 1.1, 1] }
                        : {}
                    }
                    transition={{ duration: 0.5 }}
                    className="icon-box"
                  >
                    <Target className="icon" />
                  </motion.div>
                  {htmlString[8] && parser(htmlString[8])}
                  {!htmlString[8] && <ShimmerLoaderOneLine />}
                  {!htmlString[9] && <ShimmerLoaderwhite />}
                  {htmlString[9] && parser(htmlString[9])}
                  <motion.div
                    className="card-blob"
                    animate={{ scale: hoveredCard === 1 ? [1, 1.5, 1] : 1 }}
                    transition={{ duration: 2, repeat: Infinity }}
                  />
                </div>
              </motion.div>

              {/* PASSION */}
              <motion.div
                className="card green"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 1 }}
                whileHover={{ y: -10, scale: 1.02 }}
                onHoverStart={() => setHoveredCard(2)}
                onHoverEnd={() => setHoveredCard(null)}
              >
                <div className="card-glow" />
                <div className="card-content">
                  <motion.div
                    animate={
                      hoveredCard === 2
                        ? { rotate: [0, 10, -10, 0], scale: [1, 1.1, 1] }
                        : {}
                    }
                    transition={{ duration: 0.5 }}
                    className="icon-box"
                  >
                    <Zap className="icon" />
                  </motion.div>
                  {htmlString[10] && parser(htmlString[10])}
                  {!htmlString[8] && <ShimmerLoaderOneLine />}

                  {htmlString[11] && parser(htmlString[11])}
                  {!htmlString[11] && <ShimmerLoaderwhite />}

                  <motion.div
                    className="card-blob"
                    animate={{ scale: hoveredCard === 2 ? [1, 1.5, 1] : 1 }}
                    transition={{ duration: 2, repeat: Infinity }}
                  />
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
      {userLoginData?.status === 200 && (
        <div ref={introRef} className="ticca-intro">
          <div className="ticca-intro__container">
            {/* Section Header */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="ticca-intro__header"
            >
              {htmlString[12] && parser(htmlString[12])}
              {!htmlString[12] && <ShimmerLoaderOneLine />}
              <div className="ticca-intro__underline"></div>
            </motion.div>

            {/* Cards Grid */}
            <div className="ticca-intro__grid">
              {/* Intro Card */}
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="ticca-intro__card"
              >
                <div className="ticca-intro__card-header">
                  <div className="ticca-intro__icon">
                    <FileText />
                  </div>
                  {htmlString[13] && parser(htmlString[13])}
                  {!htmlString[13] && <ShimmerLoaderOneLine />}
                </div>
                {htmlString[14] && parser(htmlString[14])}
                {!htmlString[14] && <ShimmerLoader />}
                <button
                  onClick={() => {
                    navigate(PageRoutes.Intro);
                  }}
                  className="ticca-intro__read-more"
                >
                  <span>Read more</span>
                  <ArrowRight />
                </button>
              </motion.div>

              {/* FAQ Card */}
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className="ticca-intro__card"
              >
                <div className="ticca-intro__card-header">
                  <div className="ticca-intro__icon">
                    <HelpCircle />
                  </div>
                  {htmlString[15] && parser(htmlString[15])}
                  {!htmlString[15] && <ShimmerLoaderOneLine />}
                </div>
                {htmlString[16] && parser(htmlString[16])}
                {!htmlString[16] && <ShimmerLoader />}
                <button
                  onClick={() => {
                    navigate(PageRoutes.faq);
                  }}
                  className="ticca-intro__read-more"
                >
                  <span>Read more</span>
                  <ArrowRight />
                </button>
              </motion.div>

              {/* Fact Sheet Card */}
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.6 }}
                className="ticca-intro__card"
              >
                <div className="ticca-intro__card-header">
                  <div className="ticca-intro__icon">
                    <FileSpreadsheet />
                  </div>
                  {htmlString[17] && parser(htmlString[17])}
                  {!htmlString[17] && <ShimmerLoaderOneLine />}
                </div>
                {htmlString[18] && parser(htmlString[18])}
                {!htmlString[18] && <ShimmerLoader />}
                <button
                  onClick={() => {
                    navigate(PageRoutes.factSheet);
                  }}
                  className="ticca-intro__read-more"
                >
                  <span>Read more</span>
                  <ArrowRight />
                </button>
              </motion.div>
            </div>

            {/* Bottom CTA */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.8 }}
              className="ticca-intro__cta"
            >
              <button
                onClick={() => {
                  if (accessDoc["13678"] === "ALLOWED") {
                    navigate(`${PageRoutes.ExecutiveSummary}`);
                  } else if (accessDoc["13678"] === "PENDING") {
                    setPandingBussines(true);
                  } else if (accessDoc["13678"] === "DENIED") {
                    setDeniedDocument("Business Summary");
                    setShowAccessDenied(true);
                  } else {
                    setShowCEOPopup(true);
                  }
                }}
                className="ticca-intro__cta-btn"
              >
                Learn More About TICCA
              </button>
              {htmlString[19] && parser(htmlString[19])}
              {!htmlString[19] && <ShimmerLoaderOneLine />}
            </motion.div>
          </div>
        </div>
      )}
      {userLoginData?.status === 200 && (
        <div ref={beRef} className="business-section">
          <div className="business-container">
            {/* Section Header */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="business-header"
            >
              {htmlString[20] && parser(htmlString[20])}
              {!htmlString[20] && <ShimmerLoaderOneLine />}
              <div className="header-underline" />
            </motion.div>

            {/* Card Grid */}
            <div className="business-grid">
              {cards.map((card, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: 0.2 * (i + 1) }}
                  className={`business-card ${
                    accessDoc[card.postId] === "ALLOWED"
                      ? "text-green-dev"
                      : accessDoc[card.postId] === "PENDING"
                      ? "text-yellow-dev"
                      : accessDoc[card.postId] === "DENIED"
                      ? "text-red-dev"
                      : ""
                  }`}
                  onClick={() => {
                    if (accessDoc[card.postId] === "ALLOWED") {
                      // Logic to view the document
                      navigate(`${card.href}`);
                    } else if (accessDoc[card.postId] === "PENDING") {
                      // Logic for pending access
                    } else if (accessDoc[card.postId] === "DENIED") {
                      // Logic for denied access
                      //    setDeniedDocument(card.title);
                      // setShowAccessDenied(true);
                    } else {
                      // setDeniedDocument(card.title);
                      // setShowAccessDenied(true);
                      //  setShowCEOPopup(true);
                    }
                  }}
                >
                  <motion.div
                    className="lock-icon"
                    animate={{ y: [0, -4, 0], scale: [1, 1.1, 1] }}
                    transition={{
                      duration: 2,
                      repeat: Infinity,
                      ease: "easeInOut",
                    }}
                  >
                    {accessDoc[card.postId] === "ALLOWED" ? (
                      <CheckCircle className="lock text-green" />
                    ) : accessDoc[card.postId] === "PENDING" ? (
                      <Clock className="lock text-yellow" />
                    ) : accessDoc[card.postId] === "DENIED" ? (
                      <XCircle className="lock text-red" />
                    ) : (
                      <Lock className="lock" />
                    )}
                  </motion.div>

                  <div className="card-top">
                    <div className="card-icon">{card.icon}</div>
                    {card.title && <h3>{parser(card.title)}</h3>}
                    {!card.title && <ShimmerLoaderOneLine />}
                  </div>
                  {!card.description && <ShimmerLoader />}
                  {card.description && <p>{parser(card.description)}</p>}

                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      if (accessDoc[card.postId] === "ALLOWED") {
                        // Logic to view the document
                        navigate(`${card.href}`);
                      } else if (accessDoc[card.postId] === "PENDING") {
                        // Logic for pending access
                      } else if (accessDoc[card.postId] === "DENIED") {
                        // Logic for denied access
                        //  setDeniedDocument(card.title);
                        // setShowAccessDenied(true);
                      } else {
                        // setDeniedDocument(card.title);
                        // setShowAccessDenied(true);
                      }
                    }}
                  >
                    <span>
                      {" "}
                      {accessDoc[card.postId] === "ALLOWED"
                        ? "View Content"
                        : accessDoc[card.postId] === "PENDING"
                        ? "Access Pending"
                        : accessDoc[card.postId] === "DENIED"
                        ? "Access Denied"
                        : "Request Access"}
                    </span>
                    <ArrowRight className="arrow" />
                  </button>
                </motion.div>
              ))}
            </div>

            {/* Bottom CTA */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.8 }}
              className="business-cta"
            >
              <button
                onClick={() => {
                  if (accessDoc["13678"] === "ALLOWED") {
                    // Logic to view the document
                    navigate(`${PageRoutes.question}`);
                  } else if (accessDoc["13678"] === "PENDING") {
                    // Logic for pending access
                    setpendingPop(true);
                  } else if (accessDoc["13678"] === "DENIED") {
                    // Logic for denied access
                    setShowAccessDenied(true);
                  } else {
                    setShowFinancialPopup(true);
                  }
                }}
              >
                Talk to our CEO
              </button>
              {htmlString[27] && parser(htmlString[27])}
              {!htmlString[27] && (
                <div
                  style={{
                    margin: "10px auto",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ShimmerLoaderOneLine />
                </div>
              )}
            </motion.div>
          </div>
        </div>
      )}
      {userLoginData?.status === 200 && (
        <div ref={fsRef} className="financial-summary">
          <div className="container">
            {/* Section Header */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="section-header"
            >
              {htmlString[28] && parser(htmlString[28])}
              {!htmlString[28] && (
                <div
                  style={{
                    margin: "10px auto",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ShimmerLoaderOneLine />
                </div>
              )}
              <div className="underline"></div>
            </motion.div>

            {/* Single Combined Card */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="card-wrapper"
            >
              <div className="financial-card">
                <div className="card-text">
                  {htmlString[28] && parser(htmlString[29])}
                  {!htmlString[29] && (
                    <div
                      style={{
                        margin: "10px auto",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <ShimmerLoaderOneLine />
                    </div>
                  )}
                  {!htmlString[29] && (
                    <div
                      style={{
                        margin: "10px auto",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <ShimmerLoaderOneLine />
                    </div>
                  )}
                  {!htmlString[29] && (
                    <div
                      style={{
                        margin: "10px auto",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <ShimmerLoaderOneLine />
                    </div>
                  )}
                </div>

                {/* Read More Button */}
                <div className="button-wrapper">
                  <button
                    onClick={() => {
                      if (accessDoc["13656"] === "ALLOWED") {
                        // Logic to view the document
                        navigate(`${PageRoutes.Projections}`);
                      } else if (accessDoc["13656"] == "PENDING") {
                        setpendingPop(true);
                      } else if (accessDoc["13656"] == "DENIED") {
                        setShowAccessDenied(true);
                      } else {
                        setShowFinancialPopup(true);
                      }
                    }}
                  >
                    <span>Read more</span>
                    <ArrowRight className="arrow" />
                  </button>
                </div>
              </div>
            </motion.div>

            {/* Bottom Description */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="bottom-text"
            >
              {htmlString[28] && parser(htmlString[30])}
              {!htmlString[30] && (
                <div
                  style={{
                    margin: "10px auto",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ShimmerLoaderOneLine />
                </div>
              )}
            </motion.div>
          </div>
        </div>
      )}
      {userLoginData?.status === 200 && (
        <div ref={iiRef} className="investment-instrument">
          <div className="container">
            {/* Section Header */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="section-header"
            >
              {htmlString[31] && parser(htmlString[31])}
              {!htmlString[31] && (
                <div
                  style={{
                    margin: "10px auto",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ShimmerLoaderOneLine />
                </div>
              )}
              <div className="underline"></div>
            </motion.div>

            {/* Single Tile */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="tile-wrapper"
            >
              <div className="investment-card">
                <div className="text-content">
                  {htmlString[32] && parser(htmlString[32])}
                  {!htmlString[32] && (
                    <div
                      style={{
                        margin: "10px auto",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <ShimmerLoaderOneLine />
                    </div>
                  )}
                  {!htmlString[32] && (
                    <div
                      style={{
                        margin: "10px auto",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <ShimmerLoaderOneLine />
                    </div>
                  )}
                  {!htmlString[32] && (
                    <div
                      style={{
                        margin: "10px auto",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <ShimmerLoaderOneLine />
                    </div>
                  )}
                </div>

                {/* Button */}
                <div className="button-container">
                  <button
                    onClick={() => {
                      if (accessDoc["11482"] === "ALLOWED") {
                        navigate(`${PageRoutes.SafeFrom}`);
                      } else if (accessDoc["11482"] == "PENDING") {
                        setpendingPop(true);
                      } else if (accessDoc["11482"] == "DENIED") {
                        setShowAccessDenied(true);
                      } else {
                        setShowInvestmentPopup(true);
                        return;
                      }
                    }}
                  >
                    <span>Access SAFE Agreement and be a part of TICCA</span>
                    <ArrowRight className="arrow" />
                  </button>
                </div>
              </div>
            </motion.div>

            {/* Bottom Description */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="bottom-text"
            >
              {htmlString[33] && parser(htmlString[33])}
              {!htmlString[33] && (
                <div
                  style={{
                    margin: "10px auto",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ShimmerLoaderOneLine />
                </div>
              )}
            </motion.div>
          </div>
        </div>
      )}
      {userLoginData?.status === 200 && (
        <section ref={ccRef} className="tcg__section">
          <div className="tcg__container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="tcg__header"
            >
              {htmlString[34] && parser(htmlString[34])}
              {!htmlString[34] && (
                <div
                  style={{
                    margin: "10px auto",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ShimmerLoaderOneLine />
                </div>
              )}
              <div className="tcg__divider"></div>
            </motion.div>

            <div className="tcg__grid">
              {policies.map((policy, index) => (
                <motion.div
                  key={policy.id}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="tcg__card"
                >
                  {policy.locked && (
                    <motion.div
                      className="tcg__lock"
                      animate={{
                        y: [0, -4, 0],
                        scale: [1, 1.1, 1],
                      }}
                      transition={{
                        duration: 2,
                        repeat: Infinity,
                        ease: "easeInOut",
                      }}
                    >
                      {accessDoc["12146"] === "ALLOWED" ? (
                        ""
                      ) : (
                        <Lock className="tcg__lockIcon" />
                      )}
                    </motion.div>
                  )}
                  <div className="tcg__cardHeader">
                    <div className="tcg__iconWrapper">{policy.icon}</div>
                    {htmlString[35] && parser(policy.title)}
                    {!htmlString[35] && <ShimmerLoaderOneLine />}
                  </div>
                  {htmlString[36] && parser(policy.description)}
                  {!htmlString[36] && <ShimmerLoaderwhite />}
                  {/* <p className="tcg__description">{policy.description}</p> */}
                  <button
                    onClick={() => {
                      if (policy.locked === false) {
                        navigate(`${policy.href}`);
                        return;
                      } else {
                        if (accessDoc["12146"] === "ALLOWED") {
                          navigate(`${policy.href}`);
                        } else if (accessDoc["12146"] == "PENDING") {
                          setpendingPop(true);
                        } else if (accessDoc["12146"] == "DENIED") {
                          setShowAccessDenied(true);
                        } else {
                          setShowGovernancePopup(true);
                          return;
                        }
                      }
                    }}
                    className="tcg__button"
                  >
                    {policy.locked ? (
                      <span>
                        {" "}
                        {accessDoc["12146"] === "ALLOWED"
                          ? "Read more"
                          : accessDoc["12146"] === "PENDING"
                          ? "Access Pending"
                          : accessDoc["12146"] === "DENIED"
                          ? "Access Denied"
                          : "Request Access"}
                      </span>
                    ) : (
                      <span>Read more</span>
                    )}
                    <ArrowRight className="tcg__arrow" />
                  </button>
                </motion.div>
              ))}
            </div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.9 }}
              className="tcg__footer"
            >
              {htmlString[37] && parser(htmlString[49])}
              {!htmlString[37] && <ShimmerLoaderwhite />}
            </motion.div>
          </div>
        </section>
      )}

      {userLoginData?.status === 200 && (
        <section ref={wwRef} className="ticca-www_v2">
          <div className="ticca-www_v2__inner">
            <motion.div
              className="ticca-www_v2__header"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              {htmlString[37] && parser(htmlString[50])}
              {!htmlString[37] && (
                <div
                  style={{
                    margin: "10px auto",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {" "}
                  <ShimmerLoaderOneLine />
                </div>
              )}
              <div className="ticca-www_v2__underline" />
            </motion.div>

            <div className="ticca-www_v2__grid">
              {[
                {
                  title: "Ticca.com",
                  icon: <Globe />,
                  text: `${htmlString[51]}`,
                  delay: 0.2,
                  href: "ticca.com",
                },
                {
                  title: "Ticca.ai",
                  icon: <Cpu />,
                  text: `${htmlString[52]}`,
                  delay: 0.4,
                  href: "ticca.ai",
                },
                {
                  title: "Ticca.work",
                  icon: <Briefcase />,
                  text: `${htmlString[53]}`,
                  delay: 0.3,
                  href: "",
                },

                {
                  title: "Preview.ticca.ltd",
                  icon: <Eye />,
                  text: `${htmlString[54]}`,
                  delay: 0.5,
                  href: "",
                },
              ].map((card, idx) => (
                <motion.div
              
                  key={card.title}
                  className="ticca-www_v2__card-wrapper"
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: card.delay }}
                >
                  <div   style={{opacity:`${!card.href && 0.5}`}} className="ticca-www_v2__card">
                    <motion.div
                      className="ticca-www_v2__lock"
                      animate={{ y: [0, -4, 0], scale: [1, 1.06, 1] }}
                      transition={{
                        duration: 2,
                        repeat: Infinity,
                        ease: "easeInOut",
                      }}
                    >
                      {userLoginData.status !== 200 && <Lock />}
                    </motion.div>

                    <div className="ticca-www_v2__top">
                      <div className="ticca-www_v2__icon">{card.icon}</div>
                      <h3 className="ticca-www_v2__title">{card.title}</h3>
                    </div>

                    {/* <p className="ticca-www_v2__desc">{card.text}</p> */}
                    {htmlString[34] && parser(card.text)}
                    {!htmlString[34] && <ShimmerLoaderwhite />}
                    <button
                      onClick={() => {
                        if(!card.href) return
                        if (userLoginData.status === 200) {
                          let Api_URL: any = "";
                          const env = process.env.REACT_APP_STAGE_ENV;
                          switch (env) {
                            case "dev":
                              Api_URL = `https://dev.www.${card.href}`;
                              break;
                            case "stage":
                              Api_URL = `https:/stage.www.${card.href}`;
                              break;
                            case "prod":
                              Api_URL = `https://www.${card.href}`;
                              break;
                            default:
                              Api_URL = `https://dev.www.${card.href}`;
                          }
                          window.open(Api_URL, "_blank");
                        }
                      }}
                      className="ticca-www_v2__btn"
                      type="button"
                    >
                      <span>Visit Site</span>
                      <ArrowRight className="ticca-www_v2__btn-icon" />
                    </button>
                  </div>
                </motion.div>
              ))}
            </div>
            <motion.div
              style={{ marginBottom: "20px" }}
              className="ticca-www_v2__footer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              <Button
                onClick={() => navigate(PageRoutes.ContactUs)}
                className="btn-ticca"
              >
                Connect with us
              </Button>
            </motion.div>

            <motion.div
              className="ticca-www_v2__footer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              {htmlString[55] && parser(htmlString[55])}
              {!htmlString[55] && (
                <div
                  style={{
                    margin: "10px auto",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ShimmerLoaderOneLine />
                </div>
              )}
            </motion.div>
          </div>
        </section>
      )}

      {userLoginData?.status === 200 && (
        <section className="security-notice">
          {htmlString[56] && parser(htmlString[56])}
          {!htmlString[56] && (
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <ShimmerLoaderOneLine />
            </div>
          )}
          <div className="security-notice__underline"></div>

          <div className="security-notice__card">
            <div className="security-notice__icon">
              <Shield />
            </div>

            <div className="security-notice__content">
              {htmlString[57] && parser(htmlString[57])}
              {!htmlString[56] && (
                <div
                  style={{
                    margin: "10px auto",
                    display: "flex",
                    width: "100%",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "10px",
                    justifyContent: "center",
                  }}
                >
                  <ShimmerLoaderOneLine />
                  <ShimmerLoaderOneLine />
                </div>
              )}
            </div>
          </div>
          {htmlString[38] && parser(htmlString[58])}
          {!htmlString[38] && (
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <ShimmerLoaderOneLine />
            </div>
          )}
        </section>
      )}

      {userLoginData?.status !== 200 && (
        <section className="ticca-ai-investor">
          <div className="ticca-ai-investor__container">
            {htmlString[38] && parser(htmlString[59])}
            {!htmlString[38] && (
              <div
                style={{
                  margin: "10px auto",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <ShimmerLoaderOneLine />
              </div>
            )}
            <div className="ticca-ai-investor__underline"></div>

            <div className="ticca-ai-investor__content">
              {htmlString[60] && parser(htmlString[60])}
              {!htmlString[38] && (
                <div
                  style={{
                    margin: "10px auto",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ShimmerLoaderwhite />
                </div>
              )}
              {!htmlString[38] && (
                <div
                  style={{
                    margin: "10px auto",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ShimmerLoaderwhite />
                </div>
              )}
              {!htmlString[38] && (
                <div
                  style={{
                    margin: "10px auto",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ShimmerLoaderwhite />
                </div>
              )}
            </div>

            <button
              onClick={() => {
                setInvestorPop(true);
              }}
              type="submit"
              className="ticca-ai-investor__button"
            >
              Read Intro <Lock size={18} className="lock-icon" />
            </button>
            {htmlString[60] && parser(htmlString[61])}
            {!htmlString[34] && (
              <div
                style={{
                  margin: "10px auto",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <ShimmerLoaderOneLine />
              </div>
            )}
          </div>
        </section>
      )}
      {userLoginData?.status !== 200 && (
        <section className="security-notice-investor">
          {htmlString[62] && parser(htmlString[62])}
          {!htmlString[62] && (
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <ShimmerLoaderOneLine />
            </div>
          )}
          <div className="security-notice-investor__underline" />

          <div className="security-notice-investor__card">
            <div className="security-notice-investor__icon">
              <Shield size={28} strokeWidth={1.5} />
            </div>
            <div className="security-notice-investor__content">
              {htmlString[62] && parser(htmlString[63])}
              {!htmlString[56] && (
                <div
                  style={{
                    margin: "10px auto",
                    display: "flex",
                    width: "100%",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "10px",
                    justifyContent: "center",
                  }}
                >
                  <ShimmerLoaderOneLine />
                  <ShimmerLoaderOneLine />
                </div>
              )}
            </div>
          </div>

          {htmlString[62] && parser(htmlString[64])}
          {!htmlString[38] && (
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <ShimmerLoaderOneLine />
            </div>
          )}
        </section>
      )}

        </>}
     
    </>
  );
};
export default InvestorCenter;
